import "./about.css";
import CertificationsSection from "../../components/certifications/certifications";
import ValuesSection from "./values-section/values-section";
import CareersSection from "./careers-section/careers-section";
import WhoAreWe from "./who-are-we-section/who-are-we-section";
import AboutUsHeroSection from "./about-us-hero-section/about-us-hero-section";

export default function About() {
  return (
    <div className="about-us-page">

      {/* hero section */}
      <section className="about-us-hero-section">
        <AboutUsHeroSection />
      </section>

      {/* who are we section */}
      <section className="who-are-we-section">
        <div className="who-are-we-section-width about-us-sub-container">
            <WhoAreWe />
        </div>
      </section>

      {/* certifications section */}
      <section className="about-us-certifications-section">
        <div className="about-us-certifications-section-width about-us-sub-container">
            <CertificationsSection />
        </div>
      </section>

      {/* values section */}
      <section className="values-section">
        <div className="values-section-width about-us-sub-container">
            <ValuesSection />
        </div>
      </section>

      {/* careers section */}
      <section className="careers-section">
        <div className="careers-section-width about-us-sub-container">
            <CareersSection />
        </div>
      </section>

    </div>
  );
}
